import { MISC, NP_NP, TO_BE_INITIATED, NOT_SETTLED, SETTLED, BUYER_APP, SELLER_APP, INTER_PARTICIPANT, COLLECTOR } from "../constants/constants"
export const orderData = [
    {
        "Id": 1,
        "SettlementRequestId": 1,
        "SettlementRequestItemStatusId": TO_BE_INITIATED,
        "OrderId": "2024-12-23-138156",
        "ParticipantId": "buyer-app-preprod-v2.ondc.org",
        "ParticipantRoleId": BUYER_APP,
        "ReferenceNo": "cdea43ee-d08d-40ee-995c-904f0a224f33",
        "SettlementFor": INTER_PARTICIPANT,
        "Amount": {
            "Currency": "INR",
            "Value": "30"
        },
        "CreatedOnUtc": "2024-12-30T05:45:06.028Z",
        "UpdatedOnUtc": "2024-12-30T05:45:06.028Z"
    },
    {
        "Id": 2,
        "SettlementRequestId": 1,
        "SettlementRequestItemStatusId": TO_BE_INITIATED,
        "OrderId": "2024-12-23-138156",
        "ParticipantId": "preprod-bpp.dbs.digiit.io",
        "ParticipantRoleId": SELLER_APP,
        "SettlementFor": COLLECTOR,
        "ReferenceNo": "cdea43ee-d08d-40ee-995c-904f0a224f33",
        "Amount": {
            "Currency": "INR",
            "Value": "8"
        },
        "CreatedOnUtc": "2024-12-30T05:45:06.028Z",
        "UpdatedOnUtc": "2024-12-30T05:45:06.028Z"
    }
]
